import { useEffect, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import PollCard from "../components/PollCard";

const SavedPollsPage = () => {
  const [polls, setPolls] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSaved = async () => {
      try {
        const response = await api.get("/polls/saved");
        setPolls(response.data);
      } catch (error) {
        toast.error("Unable to load saved polls.");
      } finally {
        setLoading(false);
      }
    };
    fetchSaved();
  }, []);

  const updatePoll = (updatedPoll) => {
    setPolls((prev) => prev.map((poll) => (poll.id === updatedPoll.id ? updatedPoll : poll)));
  };

  const removePoll = (pollId) => {
    setPolls((prev) => prev.filter((poll) => poll.id !== pollId));
  };

  return (
    <div className="space-y-6" data-testid="saved-polls-page">
      <div>
        <h2 className="text-2xl font-semibold" data-testid="saved-polls-title">
          Saved polls
        </h2>
        <p className="text-sm text-muted-foreground" data-testid="saved-polls-subtitle">
          Your bookmarked polls in one place.
        </p>
      </div>
      {loading ? (
        <div className="text-sm text-muted-foreground" data-testid="saved-polls-loading">
          Loading saved polls...
        </div>
      ) : polls.length === 0 ? (
        <div className="rounded-xl border border-border bg-card p-6 text-sm text-muted-foreground" data-testid="saved-polls-empty">
          No saved polls yet.
        </div>
      ) : (
        <div className="space-y-7" data-testid="saved-polls-list">
          {polls.map((poll) => (
            <PollCard key={poll.id} poll={poll} onUpdate={updatePoll} onRemove={removePoll} />
          ))}
        </div>
      )}
    </div>
  );
};

export default SavedPollsPage;
